import { Component, OnInit } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';

@Component({
  selector: 'app-pqrs',
  templateUrl: './pqrs.component.html',
  styleUrls: ['./pqrs.component.scss']
})
export class PqrsComponent implements OnInit {

  public pqrs;

  constructor(private serviciosService: ServiciosService) { }

  ngOnInit() {
    this.serviciosService.pqrs().subscribe((data)=>{
      console.log(data);
      this.pqrs = data;
    });
  }

}
